<template>
  <div class="dados_casamento">
    <div class="p-2">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label :for="`declaracao_de_hipossuficiencia-${ _uid }`"
                   class="label">
              Declaração de Hipossuficiência
            </label>
            <span class="custom-control custom-switch">
              <input
                :id="`declaracao_de_hipossuficiencia-${ _uid }`"
                v-model="habilitacao.declaracao_pobreza"
                class="custom-control-input"
                name="hipossuficiencia"
                type="checkbox">
              <label class="custom-control-label"
                     :for="`declaracao_de_hipossuficiencia-${ _uid }`">Sim</label>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-5">
          <div class="form-group">
            <label for="casamento_tipo"
                   class="label">
              Tipo de casamento <span class="text-danger">*</span>
            </label>
            <select id="casamento_tipo"
                    v-model="habilitacao.tipo_casamento"
                    v-validate="'required'"
                    class="form-control form-control-sm"
                    :class="{'is-invalid':errors.has('tipo_casamento')}"
                    required
                    name="tipo_casamento"
                    @blur="validateInputs('tipo_casamento')"
                    @change="[validateInputs('tipo_casamento'), getAddressCartorio(), liberar(), verifyDataCasamento(), verifyCasamentoCartorio()]">
              <option :value="null">
                Selecione o tipo
              </option>
              <option v-for="(tipo, index) in selects.tipo"
                      :key="`tipo_casamento_${index}`">
                {{ tipo }}
              </option>
            </select>
            <small v-if="errors.has('tipo_casamento')"
                   class="text-danger">
              Selecione o tipo de casamento.
            </small>
          </div>
        </div>

        <div v-if="propHabilitacao.registro.tipo_registro == 'D'"
             class="col-7">
          <div class="form-group">
            <label for="casamento_tipo"
                   class="label">
              Protocolo número/ano
              <span v-if="habilitacao.protocolo && habilitacao.protocolo.id"> -
                <b-link v-b-tooltip.hover.right="'Ir para detalhes do protocolo'"
                        :to="{ name: 'protocolos_detalhes', params: { id: habilitacao.protocolo.id }}"
                        target="_blank">
                  <small class="text-info"><b>Ir para protocolo</b></small>
                </b-link>
              </span>
            </label>
            <div class="row no-gutters">
              <div class="col-3">
                <input v-if="$route.name != 'editar_habilitacao_casamento'"
                       v-model="habilitacao.protocolo_numero"
                       type="number"
                       :disabled="!!habilitacao.protocolo_automatico"
                       class="form-control form-control-sm">
                <input v-if="$route.name == 'editar_habilitacao_casamento' && !habilitacao.protocolo_automatico"
                       v-model="habilitacao.protocolo_numero"
                       type="number"
                       :disabled="!!habilitacao.protocolo_automatico"
                       class="form-control form-control-sm">
                <!-- quando for protocolo automatico -->
                <input v-if="habilitacao.protocolo_automatico && $route.name == 'editar_habilitacao_casamento'"
                       v-model="habilitacao.protocolo.numero"
                       type="number"
                       disabled
                       class="form-control form-control-sm">
              </div>
              <div class="col-1 text-center mt-1">
                /
              </div>
              <div class="col-2">
                <v-select v-if="$route.name != 'editar_habilitacao_casamento'"
                          v-model="habilitacao.protocolo_ano"
                          :options="years"
                          :disabled="!!habilitacao.protocolo_automatico"
                          class="form-control form-control-sm" />
                <v-select v-if="$route.name == 'editar_habilitacao_casamento' && !habilitacao.protocolo_automatico"
                          v-model="habilitacao.protocolo_ano"
                          :options="years"
                          :disabled="!!habilitacao.protocolo_automatico"
                          class="form-control form-control-sm" />
                <!-- quando for protocolo automatico -->
                <v-select v-if="habilitacao.protocolo_automatico && $route.name == 'editar_habilitacao_casamento'"
                          v-model="habilitacao.protocolo.ano"
                          :options="years"
                          disabled
                          class="form-control form-control-sm" />
              </div>
              <div class="col">
                <div class="form-group ml-3">
                  <span class="custom-control custom-switch">
                    <input :id="`foraBrasil-${ _uid }`"
                           v-model="habilitacao.protocolo_automatico"
                           class="custom-control-input foraBrasil"
                           name="tipo_registro"
                           :disabled="$route.name == 'editar_habilitacao_casamento'"
                           type="checkbox"
                           @change="changeProcessoAutomatico()">
                    <label class="custom-control-label"
                           :for="`foraBrasil-${ _uid }`">Gerar protocolo automaticamente</label>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="propTipo != 'CASAMENTO'"
           class="row">
        <div class="col-3">
          <div class="form-group">
            <label for="dados_casamento_data_entrada"
                   class="label">
              Data de entrada <span class="text-danger">*</span>
            </label>
            <input v-if="hidden.datas"
                   id="dados_casamento_data_entrada"
                   ref="data_entrada"
                   v-model="habilitacao.data_entrada"
                   v-validate="habilitacao.tipo_casamento != A_VISTA_HABILITACAO ? `required|date_format:yyyy-MM-dd|date_between:1500-01-01,${ limitDate }` : `required`"
                   type="date"
                   required
                   :class="{'is-invalid':errors.has('data_entrada')}"
                   name="data_entrada"
                   class="form-control form-control-sm"
                   @keyup="liberar()"
                   @change="liberar(), validateInputs('data_entrada'),calcularData(0), emitChange()">
            <small v-if="errors.has('data_entrada')"
                   class="text-danger">
              {{ errors.first('data_entrada') }}
            </small>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="dados_casamento_data_entrada"
                   class="label">
              Data de habilitação <span class="text-danger">*</span>
            </label>
            <input v-if="hidden.datas"
                   id="dados_casamento_data_entrada"
                   v-model="habilitacao.data_habilitacao"
                   v-validate="habilitacao.tipo_casamento != A_VISTA_HABILITACAO ? `date_format:yyyy-MM-dd|date_between:${ habilitacao.data_entrada },${ dataLimite() }, (include)`: `required`"
                   type="date"
                   required
                   :class="{'is-invalid':errors.has('data_habilitacao')}"
                   :disabled="errors.has('data_entrada')"
                   name="data_habilitacao"
                   class="form-control form-control-sm"
                   @keyup="liberar()"
                   @change="liberar(), validateInputs('data_habilitacao'), calcularData(1), emitChange(), hidden.small_data_habilitacao = false">
            <small v-if="errors.has('data_habilitacao')"
                   class="text-danger">
              A data de habilitação deve ser no mínimo igual ou posterior à data de entrada.
            </small>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="dados_casamento_data_expiracao"
                   class="label">
              Expira em <span class="text-danger">*</span>
            </label>
            <input v-if="hidden.datas"
                   id="dados_casamento_data_expiracao"
                   v-model="habilitacao.data_expiracao"
                   v-validate="habilitacao.tipo_casamento != A_VISTA_HABILITACAO ? `date_format:yyyy-MM-dd|date_between:${ dataExpiracao() },${ dataLimite() }, (include)`: `required`"
                   type="date"
                   required
                   class="form-control form-control-sm"
                   :class="{'is-invalid':errors.has('data_expiracao')}"
                   name="data_expiracao"
                   :disabled="errors.has('data_habilitacao') || errors.has('data_entrada')"
                   @keyup="liberar()"
                   @change="liberar(), validateInputs('data_expiracao'), emitChange(), hidden.small_data_expiracao = false">
            <small v-if="!errors.has('data_expiracao')"
                   class="text-secondary">
              Data <b>90 dias após a data de habilitação</b>, é possível alterá-la.
            </small>
            <small v-if="errors.has('data_expiracao')"
                   class="text-danger">
              A data de expiração deve ser no mínimo 90 dias após a data de habilitação.
            </small>
          </div>
        </div>
      </div>

      <div class="row">
        <div v-if="habilitacao.tipo_casamento !== EDITAL_OUTRA_SERVENTIA"
             class="col-5 d-inline-flex m-0 p-0">
          <div class="col-7">
            <div v-if="propTipo == 'HABILITACAO'"
                 class="form-group">
              <label for="dados_casamento_data_entrada"
                     class="label">
                Data do Casamento
                <span v-if="[CASAMENTO_RELIGIOSO, UNIAO_ESTAVEL, CASAMENTO_CIVIL_OUTRO_CARTORIO].indexOf(habilitacao.tipo_casamento) == -1"
                      class="text-danger">*</span>
              </label>
              <div v-if="[CASAMENTO_RELIGIOSO, UNIAO_ESTAVEL, CASAMENTO_CIVIL_OUTRO_CARTORIO, CASAMENTO_RELIGIOSO_EFEITO_CIVIL].indexOf(habilitacao.tipo_casamento) === -1">
                <input id="dados_casamento_data_entrada"
                       v-model="habilitacao.data_casamento"
                       v-validate="habilitacao.tipo_casamento != A_VISTA_HABILITACAO ? `required:${habilitacao.tipo_casamento !== CASAMENTO_RELIGIOSO}|date_format:yyyy-MM-dd|date_between:${ habilitacao.data_habilitacao },${ habilitacao.data_expiracao }, (include)`: `required`"
                       type="date"
                       class="form-control form-control-sm"
                       :class="{'is-invalid':errors.has('data_casamento')}"
                       name="data_casamento"
                       :disabled="errors.has('data_habilitacao') || errors.has('data_entrada') || errors.has('data_expiracao')"
                       @blur="verifyDataCasamento()"
                       @change="verifyDataCasamento()">
                <small v-if="errors.has('data_casamento')"
                       class="text-danger">
                  <span v-if="habilitacao.tipo_casamento != A_VISTA_HABILITACAO">
                    A data precisa ser entre {{ habilitacao.data_habilitacao | date }} e {{ habilitacao.data_expiracao | date }}.
                  </span>
                  <span v-else>
                    Campo obrigatório
                  </span>
                </small>
              </div>
              <!-- quando for 'Religioso com efeito civil com Habilitação posterior' -->
              <!-- aceitara datas antererior a data de habilitacao -->
              <div v-else-if="habilitacao.tipo_casamento == CASAMENTO_RELIGIOSO_EFEITO_CIVIL">
                <input id="dados_casamento_data_entrada"
                       v-model="habilitacao.data_casamento"
                       v-validate="`required|date_format:yyyy-MM-dd|date_between:1500-01-01,${ habilitacao.data_habilitacao }, (include)`"
                       type="date"
                       name="data_casamento"
                       :class="{'is-invalid': errors.has('data_casamento')}"
                       class="form-control form-control-sm"
                       :disabled="errors.has('data_habilitacao') || errors.has('data_entrada') || errors.has('data_expiracao')"
                       @blur="validateDataCasamento">
                <small v-if="errors.has('data_casamento')"
                       class="text-danger">
                  <span v-if="errors.first('data_casamento') == 'Data limite excedida'">
                    Data de casamento precisa ser anterior ou igual à {{ habilitacao.data_habilitacao | date }}
                  </span>
                </small>
              </div>
              <!-- else -->
              <input v-else
                     id="dados_casamento_data_entrada"
                     v-model="habilitacao.data_casamento"
                     type="date"
                     name="data_casamento"
                     class="form-control form-control-sm"
                     :disabled="errors.has('data_habilitacao') || errors.has('data_entrada') || errors.has('data_expiracao')"
                     @blur="validateDataCasamento">
            </div>
            <div v-else-if="propTipo !== 'HABILITACAO' && habilitacao.tipo_casamento === UNIAO_ESTAVEL"
                 class="form-group">
              <label for="dados_casamento_data_entrada"
                     class="label"
                     :class="{'label_error': error_data}">
                Data do casamento
                <IconSvg v-if="error_data"
                         class="icon-error-campo"
                         icon="alert" />
              </label>
              <input id="dados_casamento_data_entrada"
                     ref="data_casamento"
                     v-model="habilitacao.data_casamento"
                     v-validate="`date_format:yyyy-MM-dd|date_between:${ '1500-01-01' },${ '2500-01-01' }, (include)`"
                     type="date"
                     class="form-control form-control-sm"
                     :class="{'is-invalid':errors.has('data_casamento') || error_data}"
                     name="data_casamento"
                     :disabled="errors.has('data_habilitacao') || errors.has('data_entrada') || errors.has('data_expiracao')"
                     @change="validateInputs('data_casamento'), emitChange(null,'data')">
              <small v-if="errors.has('data_casamento')"
                     class="text-danger">
                {{ errors.first('data_casamento') }}
              </small>
            </div>
            <div v-else
                 class="form-group">
              <label for="dados_casamento_data_entrada"
                     class="label"
                     :class="{'label_error': error_data}">
                Data do casamento
                <span class="text-danger">*</span>
                <IconSvg v-if="error_data"
                         class="icon-error-campo"
                         icon="alert" />
              </label>
              <input id="dados_casamento_data_entrada"
                     ref="data_casamento"
                     v-model="habilitacao.data_casamento"
                     v-validate="`required|date_format:yyyy-MM-dd|date_between:${ '1500-01-01' },${ '2500-01-01' }, (include)`"
                     type="date"
                     class="form-control form-control-sm"
                     :class="{'is-invalid':errors.has('data_casamento') || error_data}"
                     required
                     name="data_casamento"
                     :disabled="errors.has('data_habilitacao') || errors.has('data_entrada') || errors.has('data_expiracao')"
                     @change="validateInputs('data_casamento'), emitChange(null,'data')">
              <small v-if="errors.has('data_casamento')"
                     class="text-danger">
                {{ errors.first('data_casamento') }}
              </small>
            </div>
          </div>
          <div class="col-5">
            <div class="form-group">
              <label for="dados_casamento_data_entrada"
                     class="label">
                Hora do Casamento
                <span v-if="[CASAMENTO_RELIGIOSO, UNIAO_ESTAVEL, CASAMENTO_CIVIL_OUTRO_CARTORIO].indexOf(habilitacao.tipo_casamento) == -1 && habilitacao.tipo_casamento !== UNIAO_ESTAVEL"
                      class="text-danger">*</span>
              </label>
              <input id="dados_casamento_hora_casamento"
                     v-model="habilitacao.hora_casamento"
                     v-validate="{ required: [CASAMENTO_RELIGIOSO, UNIAO_ESTAVEL, CASAMENTO_CIVIL_OUTRO_CARTORIO].indexOf(habilitacao.tipo_casamento) == -1 || propTipo !== 'HABILITACAO' && habilitacao.tipo_casamento !== UNIAO_ESTAVEL}"
                     type="time"
                     class="form-control form-control-sm"
                     :class="{'is-invalid':errors.has('hora_casamento')}"
                     name="hora_casamento"
                     :required="[CASAMENTO_RELIGIOSO, UNIAO_ESTAVEL, CASAMENTO_CIVIL_OUTRO_CARTORIO].indexOf(habilitacao.tipo_casamento) == -1 || propTipo !== 'HABILITACAO' && habilitacao.tipo_casamento !== UNIAO_ESTAVEL"
                     @blur="validateInputs('hora_casamento')"
                     @change="validateInputs('hora_casamento'), emitChange()">
              <small v-if="errors.has('hora_casamento')"
                     class="text-danger">
                Digite a hora do casamento.
              </small>
            </div>
          </div>
        </div>
        <div v-if="habilitacao.tipo_casamento != null"
             class="col-5">
          <div v-if="habilitacao.tipo_casamento == CASAMENTO_RELIGIOSO || habilitacao.tipo_casamento == CASAMENTO_RELIGIOSO_EFEITO_CIVIL">
            <div class="form-group">
              <label for="casamento_celebrante"
                     class="label">
                Celebrante
              </label>
              <input id="casamento_celebrante"
                     v-model="habilitacao.celebrante"
                     v-uppercase
                     type="text"
                     class="form-control form-control-sm"
                     @change="emitChange()">
            </div>
          </div>

          <div v-else>
            <div class="form-group">
              <label for="casamento_juiz"
                     class="label">
                Juiz de casamento
              </label>
              <input id="casamento_juiz"
                     ref="nome_juiz"
                     v-model="habilitacao.juiz"
                     v-uppercase
                     type="text"
                     class="form-control form-control-sm"
                     @change="emitChange()">
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-5">
          <div class="form-group">
            <label for="casamento_regime"
                   class="label"
                   :class="{'label_error': error_regime}">
              Regime de bens
              <IconSvg v-if="error_regime"
                       class="icon-error-campo"
                       icon="alert" />
            </label>

            <select id="casamento_regime"
                    v-model="habilitacao.regime_bens"
                    v-validate="{'required': propTipo !== 'CASAMENTO'}"
                    class="form-control form-control-sm"
                    :class="{'is-invalid': error_regime || errors.has('regime_bens')}"
                    name="regime_bens"
                    @change="getComplemento(), emitChange(null, 'regime')">
              <option :value="null">
                Selecione o tipo
              </option>
              <option v-for="(regime, index) in regimeDeBens"
                      :key="`regime_casamento_${index}`"
                      :value="regime.value">
                {{ regime.text }}
              </option>
            </select>
            <small class="invalid-feedback">{{ errors.first('regime_bens') }}</small>
          </div>
        </div>
        <div class="col-5">
          <div class="form-group">
            <label for="nome_complemento"
                   class="label">
              Nome do complemento
            </label>

            <select id="nome_complemento"
                    v-model="habilitacao.nome_complemento_regime_bens"
                    class="form-control form-control-sm"
                    @change="changeComplemento">
              <option :value="null">
                Selecione o nome
              </option>
              <option v-for="(regimeComplemento, index) in complementos"
                      :key="`complemento_regime_casamento_${index}`"
                      :value="regimeComplemento.complemento">
                {{ regimeComplemento.nome }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-12">
          <div class="form-group">
            <label for="regime_bens_complemento"
                   class="label">
              Complemento
            </label>
            <textarea v-model="habilitacao.regime_bens_complemento"
                      class="form-control form-control-sm w-100"
                      placeholder="Regime de bens complemento"
                      cols="30"
                      rows="4"
                      @change="emitChange()" />
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="row">
        <div class="col">
          <sub-header-grey class="pt-2">
            <label class="label">Local de Casamento</label>
          </sub-header-grey>
        </div>
      </div>

      <div class="row">
        <div v-if="habilitacao.tipo_casamento == CASAMENTO_RELIGIOSO || habilitacao.tipo_casamento == CASAMENTO_RELIGIOSO_EFEITO_CIVIL"
             class="col">
          <div class="row mt-2 pl-2">
            <div class="col-4">
              <div class="form-group">
                <label for="dados_casamento_denominacao"
                       class="label">Denominação</label>
                <input id="dados_casamento_denominacao"
                       v-model="habilitacao.registro.local.descricao"
                       type="text"
                       class="form-control form-control-sm"
                       @change="emitChange()">
              </div>
            </div>
          </div>

          <box-endereco :no-header="true"
                        :data="habilitacao.registro.local.endereco"
                        :prop-cartorio="propCartorio"
                        @onEnderecoAdd="updateLocalOcorrencia" />
        </div>

        <div v-else
             class="col mt-3 ml-3">
          <div class="form-group">
            <span class="custom-control custom-switch">
              <input
                id="casamento_em_cartorio"
                v-model="habilitacao.casamento_em_cartorio"
                class="custom-control-input"
                name="tipo_registro"
                type="checkbox"
                @keyup.enter="changeCasamentoCartorio()"
                @change="getAddressNotCartorio()">
              <label
                class="custom-control-label"
                for="casamento_em_cartorio">Casamento em cartório</label>
            </span>
          </div>
          <box-endereco v-if="showAddress"
                        :no-header="true"
                        :data="habilitacao.registro.local.endereco"
                        :prop-cartorio="propCartorio"
                        @onEnderecoAdd="updateLocalOcorrencia" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <partes :partes="partes"
                :prop-cartorio="propCartorio"
                :prop-header="propTipo == 'CASAMENTO' ? 'Testemunhas' : 'Partes'"
                :read-only="true"
                :prop-tipo="propTipo"
                :prop-registro="propHabilitacao.pessoas"
                :prop-registro-salvo="propHabilitacao.registro.pessoas"
                @ParteAdded="addParte"
                @ParteRemoved="removeParte"
                @ParteUpdated="updateParte"
                @removeEndereco="removeEnderecoParte" />
      </div>
    </div>

    <div>
      <div class="row">
        <div class="col">
          <sub-header-grey class="pt-2">
            <label class="label">Complementos</label>
          </sub-header-grey>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group p-2">
            <label for="casamento_complemento"
                   class="label">Informações adicionais</label>
            <textarea id="casamento_complemento"
                      v-model="habilitacao.registro.complemento"
                      name=""
                      class="form-control form-control-sm"
                      cols="30"
                      rows="4"
                      @change="emitChange()" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="propTipo !='CASAMENTO'">
      <div class="row">
        <div class="col">
          <sub-header-grey class="pt-2">
            <label class="label">Publicação de edital</label>
          </sub-header-grey>
        </div>
      </div>
      <div class="row pt-2 px-2">
        <div class="col">
          <div class="form-group m-0 mb-2">
            <label for="local_publicacao"
                   class="label">Escolha o local de publicação do edital</label>
            <div id="local_publicacao"
                 class="col-12 m-0 p-0 d-inline-flex">
              <span class="custom-control custom-radio custom-control-inline align-items-center">
                <input
                  id="E_PROCLAMAS"
                  v-model="publicacao"
                  type="radio"
                  name="E_PROCLAMAS"
                  value="E_PROCLAMAS"
                  :disabled="(isConverted) || propTipo === 'CASAMENTO'"
                  class="custom-control-input"
                  @click="localPublicacao('E_PROCLAMAS')"
                  @keyup.enter="changeTipo('E_PROCLAMAS')">
                <label
                  class="custom-control-label fs-14"
                  for="E_PROCLAMAS">e-Proclamas</label>
              </span>
              <span class="custom-control custom-radio custom-control-inline align-items-center">
                <input
                  id="OUTRO_JORNAL"
                  v-model="publicacao"
                  type="radio"
                  name="OUTRO_JORNAL"
                  value="OUTRO_JORNAL"
                  :disabled="isConverted"
                  class="custom-control-input"
                  @click="changeJornal()"
                  @keyup.enter="changeTipo('OUTRO_JORNAL')">
                <label
                  class="custom-control-label fs-14"
                  for="OUTRO_JORNAL">Jornal</label>
              </span>
              <span class="custom-control custom-radio custom-control-inline align-items-center">
                <input
                  id="NAO_PUBLICAR"
                  v-model="publicacao"
                  type="radio"
                  name="NAO_PUBLICAR"
                  value="NAO_PUBLICAR"
                  class="custom-control-input"
                  :disabled="isConverted"
                  @click="localPublicacao('NAO_PUBLICAR')"
                  @keyup.enter="changeTipo('NAO_PUBLICAR')">
                <label
                  class="custom-control-label fs-14"
                  for="NAO_PUBLICAR">Dispensada</label>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="publicacao === 'OUTRO_JORNAL'"
           class="row p-2 mb-2">
        <div class="col-5">
          <label for="nome_jornal"
                 class="label">Nome do jornal que o edital será publicado</label>
          <input v-model="habilitacao.publicacao"
                 v-validate="'required'"
                 type="text"
                 class="form-control form-control-sm"
                 :disabled="isConverted"
                 :class="{'is-invalid': errors.has('nome_jornal')}"
                 name="nome_jornal"
                 @change="emitChange()">
          <span v-if="errors.has('nome_jornal')"
                class="invalid-feedback">
            {{ errors.first('nome_jornal') }}
          </span>
        </div>
        <div class="col-2">
          <label for="nome_jornal"
                 class="label">Data da publicação</label>
          <input v-model="habilitacao.data_publicacao"
                 v-validate="'required'"
                 type="date"
                 class="form-control form-control-sm"
                 :disabled="isConverted"
                 :class="{'is-invalid': errors.has('data_publicacao')}"
                 name="data_publicacao"
                 @change="emitChange()">
          <span v-if="errors.has('nome_jornal')"
                class="invalid-feedback">
            {{ errors.first('data_publicacao') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import BoxEndereco from "@/components/SofiaRei/BoxEndereco"
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"
  import Partes from "@/components/SofiaRei/Obito/Passos/Sessoes/Partes"
  import TextAutoComplete from "../TextAutoComplete.vue"

  /* services */
  import RegimeBensService from "@/services/Registros/RegimeBensService"

  /* constants */
  import { tipos, EDITAL_OUTRA_SERVENTIA, A_VISTA_HABILITACAO, UNIAO_ESTAVEL, CASAMENTO_RELIGIOSO_EFEITO_CIVIL, CASAMENTO_RELIGIOSO, CASAMENTO_CIVIL_OUTRO_CARTORIO } from "@/constants/casamento/tipos"

  /* others */
  import moment from "moment"
  import {mapGetters} from "vuex"

  export default {
    name: "DadosCasamento",
    components: {
      BoxEndereco,
      SubHeaderGrey,
      Partes,
      TextAutoComplete
    },
    props: {
      propHabilitacao: {type: Object, default: () => ({})},
      propTipo: {type: String, default: () => 'HABILITACAO'},
      propCartorio: {type: Object, default: () => ({})},
      propCorrecoes: {type: Object, default: () => ({})},
      propEdicao: { type: Boolean, default: () => false },
      propTab: {type: Number, default: () => 0}
    },
    inject: ['$validator'],
    data () {
      return {
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
        selects: {
          tipo: [
            ...tipos
          ],
          regime: [
            { text: "Comunhão parcial de bens" },
            { text: "Comunhão universal de bens" },
            { text: "Participação final aquestos" },
            { text: "Separação de Bens" },
            { text: "Separação legal de bens" },
            { text: "Outros" },
            { text: "Ignorado" }
          ]
        },
        hidden: {
          datas: true,
          small_data_habilitacao: false,
          small_data_expiracao: false
        },
        habilitacao: {
          tipo_casamento: null,
          regime_bens: null,
          nome_complemento_regime_bens: null,
          regime_bens_complemento: null,
          publicacao: 'E_PROCLAMAS',
          data_publicacao: null,
          data_casamento: null,
          hora_casamento: null,
          protocolo_numero: null,
          protocolo_ano: null
        },
        publicacao: 'E_PROCLAMAS',
        complementos: [],
        partes: [],
        regimeDeBens: [
          { value: 'COMUNHAO_PARCIAL', text: "Comunhão parcial de bens" },
          { value: 'COMUNHAO_UNIVERSAL', text: "Comunhão universal de bens" },
          { value: 'PARTICIPACAO_FINAL_AQUESTOS', text: "Participação final aquestos" },
          { value: 'SEPARACAO_BENS', text: "Separação de Bens" },
          { value: 'SEPARACAO_LEGAL_BENS', text: "Separação legal de bens" },
          { value: 'OUTROS', text: "Outros" },
          { value: 'IGNORADO', text: "Ignorado" }
        ],
        showAddress: false,
        error_data: false,
        error_regime: false,
        error_observacoes: false,
        A_VISTA_HABILITACAO,
        EDITAL_OUTRA_SERVENTIA,
        UNIAO_ESTAVEL,
        CASAMENTO_RELIGIOSO_EFEITO_CIVIL,
        CASAMENTO_RELIGIOSO,
        CASAMENTO_CIVIL_OUTRO_CARTORIO
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
      isConverted () {
        return this.habilitacao.habilitacao_casamento_id && this.propTipo === 'CASAMENTO'
      },
      years () {
        let yearActual = new Date().getFullYear()
        let years = []

        for (let year = yearActual; year >= 1900; year--) {
          years.push(year)
        }

        return years
      }
    },
    watch: {
      propHabilitacao () {
        this.habilitacao = this.propHabilitacao
        this.init()
        setTimeout(() => this.activeChange(), 100)
        this.getComplemento()
        this.getPublicacao()

        this.showAddress = !this.habilitacao.casamento_em_cartorio
      },
      propCorrecoes () {
        this.verifyErrorsCarga()
      },
      propTab () {
        if (this.propTab == 2) {
          this.verifyFocus()
        }
      }
    },

    created () {
      this.habilitacao = this.propHabilitacao

      // Alguns legados não vem com local nem endereço
      if (!this.habilitacao.registro.local) {
        this.habilitacao.registro.local = {
          endereco: {}
        }
      }

      this.showAddress = !this.habilitacao.casamento_em_cartorio
    },

    mounted () {
      this.ativarData()
      this.liberar()
      this.getComplemento()
      this.init()
      this.verifyErrorsCarga()
      this.getPublicacao()
      this.verifyFocus()
    },
    methods: {
      init () {
        this.partes = this.propHabilitacao.registro.partes

        if (this.habilitacao.hora_casamento) {
          this.habilitacao.hora_casamento = moment(this.habilitacao.hora_casamento, 'HH:mm').format('HH:mm')
        }
      },
      dataExpiracao () {
        return moment(this.habilitacao.data_habilitacao).add(90,"day").format("YYYY-MM-DD")
      },
      dataLimite () {
        return moment(this.habilitacao.data_habilitacao).add(10,"year").format("YYYY-MM-DD")
      },
      emitChange (deleteds = null, field) {
        if (field) {
          switch (field) {
          case 'data':
            this.deleteError([`DATA DO CASAMENTO`])
          case 'regime':
            this.deleteError([`REGIME DO CASAMENTO`, 'REGIME DE BENS'])
          }
        }

        if (deleteds !== null) {
          this.$emit('onDeleteds', deleteds)
        }

        this.$emit('onChange', this.habilitacao)
        this.liberar()
      },
      validateCpf (parte) {
        const conjuges = this.propHabilitacao.registro.pessoas || this.propHabilitacao.pessoas

        const conjugeComMesmoCpf = conjuges.filter((conjuge) => {
          if (conjuge.cpf && parte.pessoa.cpf) {
            return conjuge.cpf === parte.pessoa.cpf
          }
        })

        if (conjugeComMesmoCpf.length) {
          objSwal.error.title = 'Erro ao cadastrar declarante'
          objSwal.error.text = `O CPF ${parte.pessoa.cpf} já cadastrado para um conjuge`
          Swal.fire(objSwal.error)

          return false
        }

        return true
      },
      addParte (parte) {
        if (!this.validateCpf(parte)) return

        if (this.propHabilitacao.registro_id) {
          parte.registro_id = this.propHabilitacao.registro_id
        }
        this.habilitacao.registro.partes.push(parte)
        this.emitChange()
      },

      /*updateParte (parte) {
        this.habilitacao.registro.partes[parte.localId].pessoa = { ...parte.pessoa };
        this.emitChange();
      },*/

      updateLocalOcorrencia (local) {
        const localOcorrencia = {
          tipo: "Igreja",
          endereco: local
        }
        Object.assign(this.habilitacao.registro.local, localOcorrencia)
        this.emitChange()
      },

      async updateParte (parte) {
        this.habilitacao.registro.partes[parte.localId].pessoa = { ...parte.pessoa }

        if (this.propTipo) {
          this.habilitacao.registro.partes[parte.localId].tipo = parte.tipo
        }

        this.emitChange()
      },

      removeParte (part, index) {
        const { partes } = this.habilitacao.registro

        let deleteds = null

        if (partes[index] && partes[index].parte_id) {
          deleteds = {
            partes: partes[index].parte_id
          }
        }

        partes.splice(index, 1)
        this.emitChange(deleteds)
      },

      calcularData (index) {
        this.hidden.datas = false
        const datas = [
          {
            qtd: 6, // aumentando de 5 para 6
            origem: 'data_entrada',
            destino: 'data_habilitacao',
          },
          {
            qtd: 90, // O primeiro dia sera 1 dia apos a data de habilitacao 
            origem: 'data_habilitacao',
            destino: 'data_expiracao'
          }
        ]

        for (let i = index; i < datas.length; i++) {
          const dataDestino = moment(this.habilitacao[datas[i].origem]).add(datas[i].qtd, 'day').format('YYYY-MM-DD')

          if (dataDestino.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/)) {
            this.habilitacao[datas[i].destino] = dataDestino
            this.hidden[`small_${datas[i].destino}`] = true
          } else if (index == 0) {
            break
          }

        }

        this.hidden.datas = true
      },

      async activeChange (name = null) {
        if (await this.$validator.validate(name)) {
          if (!name) {
            this.$emit('onActive', true, 2)
          }
        } else {
          this.$emit('onActive', false, 2)
        }
      },

      validateInputs (name) {
        this.$validator.validate(name)

        if (name === 'tipo_casamento') this.verifyDataEHora()
      },

      dataAtual () {
        this.habilitacao.data_entrada = moment().format('YYYY-MM-DD')
      },

      ativarData () {
        if (!this.habilitacao.data_entrada) {
          this.dataAtual()
          this.calcularData(0)
          //this.emitChange();
        }
      },

      liberar () {
        setTimeout(() => {
          const {
            data_entrada,
            data_habilitacao,
            data_expiracao,
            data_casamento,
            hora_casamento,
            tipo_casamento,
            regime_bens
          } = this.habilitacao

          if (([this.CASAMENTO_RELIGIOSO, this.UNIAO_ESTAVEL, this.CASAMENTO_CIVIL_OUTRO_CARTORIO].indexOf(tipo_casamento) !== -1) && data_entrada && data_habilitacao && data_expiracao && regime_bens) {
            this.activeChange()
          } else if (data_entrada && data_habilitacao && data_expiracao && data_casamento && hora_casamento && tipo_casamento && regime_bens) {
            this.activeChange()
          } else {
            this.$emit('onActive', false, 2)
          }
        }, 1000)
      },
      async getComplemento () {
        if (!this.habilitacao.regime_bens) return

        const { data } = await RegimeBensService.getRegimeBens({
          cartorio_id: this.$store.state.auth.cartorio_id,
          descricao: this.habilitacao.regime_bens,
          ativo: true
        })

        this.complementos = data

        this.emitChange()
      },
      changeComplemento (event) {
        const val = event.target.value

        this.habilitacao.regime_bens_complemento = val

        this.emitChange()
      },
      removeEnderecoParte (endereco) {
        if (endereco.endereco_id) {
          const deleteds = {
            pessoaEnderecos: endereco.endereco_id
          }
          this.emitChange(deleteds)
        }
      },
      getAddressCartorio () {
        if (this.habilitacao.registro.local && this.habilitacao.registro.local.endereco) {
          const endereco = !!Object.values(this.habilitacao.registro.local.endereco).length

          if (endereco) {
            this.emitChange()
            return
          }
        }

        this.habilitacao.registro.local.endereco = {
          uf: this.propCartorio.endereco ? this.propCartorio.endereco.uf : '',
          cidade: this.propCartorio.endereco ? this.propCartorio.endereco.cidade : '',
          ibge: this.propCartorio.endereco ? this.propCartorio.endereco.ibge : null,
        }

        this.emitChange()
      },

      getAddressNotCartorio () {
        setTimeout(() => {
          this.habilitacao.casamento_em_cartorio = !!this.habilitacao.casamento_em_cartorio
          this.emitChange()

          this.showAddress = !this.habilitacao.casamento_em_cartorio
        }, 300)

        if (this.habilitacao.casamento_em_cartorio) {
          this.habilitacao.registro.local.endereco = {
            uf: this.propCartorio.endereco ? this.propCartorio.endereco.uf : '',
            cidade: this.propCartorio.endereco ? this.propCartorio.endereco.cidade : '',
            ibge: this.propCartorio.endereco ? this.propCartorio.endereco.ibge : null,
          }
        } else {
          this.habilitacao.registro.local.endereco = {}
        }

        this.emitChange()
      },
      verifyErrorsCarga () {
        this.error_data = false
        this.error_regime = false

        Object.keys(this.propCorrecoes).forEach(key => {
          if ([`DATA DO CASAMENTO`].indexOf(key) != -1) this.error_data = true
          if ([`REGIME DO CASAMENTO`, 'REGIME DE BENS'].indexOf(key) != -1) this.error_regime = true
        })
      },
      deleteError (errors) {
        this.$emit('deleteError', errors)
      },
      localPublicacao (local) {
        this.habilitacao.publicacao = local

        this.emitChange()
      },
      getPublicacao () {
        const {publicacao} = this.habilitacao
        // deixando no formato de data
        this.habilitacao.data_publicacao = this.habilitacao.data_publicacao ? moment(this.habilitacao.data_publicacao).format('YYYY-MM-DD') : null

        if (publicacao === 'E_PROCLAMAS' || publicacao === 'NAO_PUBLICAR') {
          this.publicacao = publicacao
        } else {
          this.publicacao =  'OUTRO_JORNAL'
        }
      },
      changeJornal () {
        this.habilitacao.publicacao = null
        this.habilitacao.data_publicacao = null
      },
      changeCasamentoCartorio () {
        this.habilitacao.casamento_em_cartorio = !this.habilitacao.casamento_em_cartorio

        this.getAddressNotCartorio()
      },
      verifyDataCasamento () {
        if (!this.habilitacao.data_casamento) {
          this.habilitacao.data_casamento === null
        }

        this.validateInputs('data_casamento')
        this.liberar()
      },
      verifyDataEHora () {
        if (this.habilitacao.tipo_casamento === this.EDITAL_OUTRA_SERVENTIA) {
          this.habilitacao.data_casamento = null
          this.habilitacao.hora_casamento = null

          this.emitChange(null, 'data')
        }
      },
      validateDataCasamento (input) {
        this.habilitacao.data_casamento = input.target.value

        this.verifyDataCasamento()
      },
      verifyFocus () {
        if (this.propTipo == 'CASAMENTO' && this.propHabilitacao.registro_id) {
          if (this.habilitacao.tipo_casamento == 'Afixação de edital de outra serventia' && this.$refs["nome_juiz"]) {
            this.$refs["nome_juiz"].focus()
          } else if (this.$refs["data_casamento"]) {
            this.$refs["data_casamento"].focus()
          }
        }
        else {
          if (this.propTipo == 'CASAMENTO' && this.$refs["tipo_casamento"]) {
            this.$refs["tipo_casamento"].focus()
          } else if (this.$refs["data_entrada"]) {
            this.$refs["data_entrada"].focus()
          }
        }
      },
      changeTipo (tipo) {
        this.publicacao = tipo

        if (tipo == 'OUTRO_JORNAL') {
          this.changeJornal()
        } else {
          this.localPublicacao(tipo)
        }
      },
      verifyCasamentoCartorio () {
        if (this.habilitacao.tipo_casamento == this.CASAMENTO_RELIGIOSO || this.habilitacao.tipo_casamento == this.CASAMENTO_RELIGIOSO_EFEITO_CIVIL) {
          this.habilitacao.casamento_em_cartorio = false
        } else {
          this.habilitacao.casamento_em_cartorio = true
        }
      },
      changeProcessoAutomatico () {
        if (this.habilitacao.protocolo_automatico) {
          this.habilitacao.protocolo_ano = null
          this.habilitacao.protocolo_numero = null
        } else {
          this.habilitacao.protocolo_ano = moment().year()
        }
        this.emitChange()
      },
    }
  }
</script>

<style lang="scss">
  @import "../../../scss/_components/resumos";

  .fs-14 {
    font-size: 14px;
  }

</style>
